import { z } from "zod";

// Set before importing any application schemas. The interpreter avoids Zod's
// dynamic-code capability probe and runs under script-src 'self'.
z.config({ jitless: true });
